import React from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import CroField from "./CroField";
import AutoComplete from "../../../../components/form/AutoComplete";
import Input from "../../../../components/form/Input";
import * as V from "../../../../utils/formValidation";
import { isCountryCz } from "../../CroUtils";
import { isPlainObject } from "lodash";

const CroMunicipality = ({
  isCZ,
  disabled,
  name,
  title,
  className,
  helpEnum,
  url,
  municipality,
  validate = [] /*, country, form */,
}) => {
  if (isCZ) {
    const reload = !disabled && municipality ? !isPlainObject(municipality) && !municipality.id : false
    return (
      <CroField
        className={className}
        title={title}
        name={`${name}.municipality`}
        component={AutoComplete}
        url="/api/ciselniky/mesta"
        disabled={disabled}
        validate={[V.isDictionary, ...validate]}
        helpEnum={helpEnum}
        dataSourceConfig={{ value: "id", text: "fullName" }}
        operation="STARTWITH"
        reload={reload}
      />
    );
  } else {
    return (
      <CroField
        className={className}
        title={title}
        name={`${name}.municipality`}
        component={Input}
        disabled={disabled}
        validate={validate}
        helpEnum={helpEnum}
      />
    );
  }
};

export default connect((state, { name, form }) => ({
  isCZ: isCountryCz(formValueSelector(form)(state, `${name}.country`)),
  municipality: formValueSelector(form)(state, `${name}.municipality`),
}))(CroMunicipality);
